import React from "react";
import FaqContainer from "../../faq/FaqContainer";
import YellowDivider from "../../dividers/YellowDivider";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

const ABOUT_ZEFI_FAQ = {
  en: [
    {
      question:
        "Do I need to have any technical knowledge to learn about blockchain?",
      answer:
        "A previous knowledge of the subject is not required. Technical or not, you are at the right place to get started and familiarize yourself with the blockchain space from no knowledge at all to becoming fully able to understand how this technique works, as well as its applications in our daily lives. Check out our courses here.",
    },
    {
      question: "Do you provide financial advice?",
      answer:
        "We’re not financial advisors. All articles published in our platform express the opinion of the author, and don’t necessarily express the opinion of ZeFi. Simply put: No. ZeFi has not and will not provide any financial or investment advice.",
    },
    {
      question: "What languages does ZeFi support?",
      answer:
        "Our content is primarily written in English & Arabic for the time being . We plan to add other languages in the future especially when it comes to the marginalized communities who have no access to the blockchain knowledge using their mother tongues.",
    },
    {
      question:
        "Should I worry about my personal data being collected on your website?",
      answer:
        "Not at all! We're committed to protecting your privacy and we don't collect any personal data. If you sign up for our newsletter we promise to not sell or give your email address to anyone! You’ll also be able to simply sign up or sign in using your web3 credentials.",
    },
    {
      question: "What do ZeFi services and projects include?",
      answer:
        "Our services currently include, but are not limited to providing a wide range of daily discussions on blockchain-related matters such as news, feature articles, opinion pieces and case studies, as well as introducing a distinctive technical glossary, and a gamified experience to learn about the blockchain space and the key concepts of the technology. In addition, we provide capacity building workshops to civil society groups, educational institutions and companies from different sectors. Keep posted because much more is yet to come!",
    },
    {
      question:
        "Are there any fees to pay to have access to ZeFi published content?",
      answer:
        "We believe that knowledge should be accessible to everyone, thus there is no fee to be paid to read content that is published in our ZeCafe section. Currently, all our courses that are available in the ZeAcademy section are free of charge as well.",
    },
  ],
  ar: [
    {
      question:
        "هل يجب أن يكون لديّ خبرة تقنيّة مسبقة كي أستطيع التعلّم عن البلوكتشين؟",
      answer:
        "لا يشترط وجود معرفة سابقة بالموضوع. أنت الآن في المكان الصحيح لأخذ الخطوة الأولى في رحلة التعلّم عن البلوكتشين من الألف إلى الياء، وفهم كيفيّة عمل هذه التقنيّة، وتطبيقها في حياتنا اليوميّة. اضغط/ي هنا لمعرفة المزيد عن دروسنا. ",
    },
    {
      question: "هل تقدّم زيفاي استشارات ماليّة؟ ",
      answer:
        "نحن لسنا استشاريّين ماليّين. تعبّر جميع المقالات الموجودة على منصّتنا عن رأي كاتبها/كاتبتها، ولا تعبّر بالضرورة عن رأي زيفاي. بكلماتٍ أخرى: كلا. لا نقدّم في زيفاي أيّ استشارة ماليّة أو استثماريّة، لا في الوقت الحاليّ ولا في المستقبل.",
    },
    {
      question: "ما اللغات التي تدعمها منصّة زيفاي؟",
      answer:
        "في الوقت الحاليّ نكتب المحتوى الخاصّ بنا باللغتين العربيّة والإنجليزيّة. نخطّط لإضافة لغات أخرى في المستقبل لا سيّما لغات المجتمعات الأكثر تهميشاً، والتي لا تمتلك القدرة على الوصول إلى المعرفة عن البلوكتشين باستخدام لغاتها الأمّ.",
    },
    {
      question: "هل تجمع زيفاي البيانات الشخصيّة؟",
      answer:
        'على الإطلاق! نلتزم في زيفاي بحماية خصوصيّتك. لا نجمع المعلومات الشخصيّة، ولا نبيعها لأيّ طرف. لن نسأل عن بريدك الإلكترونيّ أيضاً، إلّا بحال أردت الاشتراك في نشرة زي "مثلاً"، كما نعمل على تطوير وسائل لامركزيّة لإنشاء حسابك الشخصيّ على زيفاي (كدمج موقعنا بالمحافظ الإلكترونيّة اللامركزيّة).',
    },
    {
      question: "ماذا تتضمّن الخدمات والمشاريع التي تقدّمها زيفاي؟",
      answer:
        "تتضمّن خدماتنا حاليّاً مجموعة واسعة من النقاشات المرتبطة بالبلوكتشين، وتشمل على سبيل المثال لا الحصر: الأخبار، والمقالات التحليليّة، ومقالات الرأي، ودراسات الحالة. كذلك نقدّم  تجربة تعليم تفاعليّة عن تقنيّة البلوكتشين، وتطبيقاتها، والمفاهيم ذات الصلة. كما أنّنا في صدد إطلاق قاموس مصطلحات تقنيّة سيكون الأوّل من نوعه في العالم العربيّ، بالإضافة إلى تقديم ورشات عمل وبرامج تمكين لمجموعات المجتمع المدنيّ، والمؤسّسات التعليميّة، والشركات من مختلف القطاعات. إبق/ي على اطلاع للحصول على آخر الإضافات",
    },
    {
      question:
        "هل يوجد أيّ رسوم ماليّة من أجل الوصول إلى المحتوى الذي تنشره زيفاي؟",
      answer:
        'نؤمن أنّ الوصول إلى المعرفة حقّ للجميع، ومن هذا المنطلق لا يوجد أيّ بدل ماليّ مقابل قراءة المحتوى الذي ننشره في قسم "مقهى زي"، أو متابعة الدروس المتوفّرة في قسم "أكاديميّة زي".',
    },
  ],
};

const AboutZeFiFaq: React.FC = () => {
  const { i18n, ready, t } = useTranslation();

  const getFaqItems = () => {
    if (i18n.language === "ar") {
      return <FaqContainer faqs={ABOUT_ZEFI_FAQ.ar} />;
    }
    return <FaqContainer faqs={ABOUT_ZEFI_FAQ.en} />;
  };

  return (
    <div className="container mt-4">
      <div className="mb-3 mb-lg-4">
        <h2>{ready ? t("about-zefi.faq.title") : <Skeleton width={350} />}</h2>
        <YellowDivider heading="h2" />
      </div>
      {getFaqItems()}
    </div>
  );
};

export default AboutZeFiFaq;
